export default __webpack_public_path__ + "locales/hy-AM/PreparationPortal.json?hash=d9383741d1bf46bf671d6efccae17d4d";